import React from 'react'
import Design from 'app/layout/Design'
import { Routes, Route } from 'react-router-dom'
import Show from 'app/layout/Show'
import CurrentDodoneResolver from 'app/dodones/CurrentResolver'

export default () => {
  return <div className="body">
           <Routes>
             <Route path="/" element={<CurrentDodoneResolver />} />
             <Route path="/design" element={<Design />} />
             <Route path="/dodones/:id" element={<Show entityName="dodone" />} />
           </Routes>
         </div>;
};
